import { useRef } from 'react'
import { useNavigation } from 'react-router'

export const useLatestFormValue = <T extends string>(
  inputName: string,
): T | undefined => {
  const navigation = useNavigation()
  const ref = useRef<T | undefined>(undefined)
  const formData = navigation?.formData
  if (formData) {
    ref.current = (formData.get(inputName) || undefined) as T | undefined
  }
  return ref.current
}

/**
 * Returns the form intent that was submitted last
 * or undefined if no intent was submitted yet.
 * */
export const useLatestFormIntent = <T extends string>(): T | undefined => {
  return useLatestFormValue<T>('intent')
}
